import { Options } from "common";
import api from "app/api";

export type IntegrationHistoryListItem = {
  id: number;
  integration_id: number;
  title: string;
  success: number; //boolean
  request: any;
  response: string;
  begin_at: string;
  end_at: string;
};
export type IntegrationHistoryFormItem = {} & IntegrationHistoryListItem;

export type IntegrationHistoryOptions = Options;

export function getIntegrationHistoryService() {
  return api.getService<
    IntegrationHistoryFormItem,
    IntegrationHistoryListItem,
    IntegrationHistoryOptions
  >("integration-history-entries");
}
